import { render, staticRenderFns } from "./db-arrow-up.vue?vue&type=template&id=fb19b4f2&"
import script from "./db-arrow-up.vue?vue&type=script&lang=js&"
export * from "./db-arrow-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports